<template>
  <p class="ColumnParagraph">
    <slot />
  </p>
</template>

<script>
import './style.scss'

export default {
  name: 'ColumnParagraph',
}
</script>
